// extracted by mini-css-extract-plugin
export default {"empty-store":"EmptyStore_empty-store__+fX9y","modal-content":"EmptyStore_modal-content__F1dxi"};